import elementLoader from "assets/svg/elementLoader.svg";
import logo from "assets/svg/logo.svg";
import empty from "assets/svg/empty.svg";

export default {
    elementLoader,
    logo,
    empty,
};
